import React from 'react';
import { Button } from '../common/Button';
import useI18n from '../../hooks/useI18n';

interface InfoPopupProps {
  show: boolean;
  onClose: () => void;
}

const InfoPopup: React.FC<InfoPopupProps> = ({ show, onClose }) => {
  const { t } = useI18n();

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-sm lg:max-w-lg mx-4 shadow-lg">
        <h2 className="text-xl font-semibold mb-4">{t('bulkUpload.title')}</h2>
        <div className="text-sm text-gray-700">
          <p className="font-bold">{t('bulkUpload.campaignNameAndTags')}:</p>
          <ul className="list-disc pl-5 mb-4">
            <li>{t('bulkUpload.characterLimit', { min: 3, max: 200 })}</li>
            <li>
              {t('bulkUpload.allowedCharacters')}:{' '}
              {t('bulkUpload.lettersNumbersSpaces')}
            </li>
          </ul>
          <p className="font-bold">{t('bulkUpload.prefixAndSuffix')}:</p>
          <ul className="list-disc pl-5">
            <li>{t('bulkUpload.minimumCharacters', { count: 5 })}</li>
            <li>
              {t('bulkUpload.allowedCharacters')}:{' '}
              {t('bulkUpload.lowercaseLettersNumbers')}
            </li>
            <li>{t('bulkUpload.uniqueness')}</li>
          </ul>
        </div>
        <div className="flex justify-end mt-6">
          <Button variant="outlined" onClick={onClose}>
            {t('common.close')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default InfoPopup;
